import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfbe11d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user__avatar" }
const _hoisted_2 = { class: "user__username" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['user', $props.vClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Avatar, {
        avatarUrl: $props.avatarUrl,
        vClass: $props.vClass
      }, null, 8, ["avatarUrl", "vClass"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString($props.username), 1),
      _renderSlot(_ctx.$slots, "desc", {}, undefined, true)
    ])
  ], 2))
}